import React, { useState } from "react";
import { Tab, TabList, Tabs } from "@mui/joy";
import WinterRegister from "./winterregister";
import WinterPresentationList from "./winterpresentationlist";

/**
 * 본사직원페이지 > '윈터 스쿨 등록 관리' 탭 — 하위 메뉴 2개.
 *  0 윈터스쿨 등록관리        : suneungsunbae.com/winter 사전 예약 신청자 (winterregister.tsx, 기존)
 *  1 윈터스쿨 설명회 신청자 관리 : suneungsunbae.com/2027winterpresentation 설명회 예약자 + 회차 접수 상태 (winterpresentationlist.tsx)
 * 상위 탭(main.tsx) 과 구분되도록 작은 Joy Tabs 를 쓴다.
 */
const WinterRegisterMain: React.FC<any> = (props) => {

    const [sub, setSub] = useState<number>(0);

    return (
        <div style={{ width: "100%" }}>
            <Tabs
                size="sm"
                value={sub}
                onChange={(e: any, value: any) => setSub(+value)}
                sx={{ width: "96%", marginTop: "24px", backgroundColor: "transparent" }}
            >
                <TabList>
                    <Tab>윈터스쿨 등록관리</Tab>
                    <Tab>윈터스쿨 설명회 신청자 관리</Tab>
                </TabList>
            </Tabs>

            {sub === 0 && <WinterRegister user={props.user} />}
            {sub === 1 && <WinterPresentationList user={props.user} />}
        </div>
    );
};

export default WinterRegisterMain;
